import { Button } from '@/components/ui/button'

interface FormFooterProps {
  isGameCompleted: boolean
  isSubmitting: boolean
  isSaving: boolean
  openChatBoxesCount: number
  onCancel: () => void
  onSave: () => void
}

export default function FormFooter({
  isGameCompleted,
  isSubmitting,
  isSaving,
  openChatBoxesCount,
  onCancel,
  onSave,
}: FormFooterProps) {
  if (isGameCompleted) {
    return null
  }

  const isDisabled = openChatBoxesCount !== 0

  return (
    <div className='border-t border-gray-200 p-6 bg-white'>
      <div className='flex justify-end gap-4'>
        <Button
          type='button'
          size='lg'
          className='bg-dark-blue hover:bg-dark-blue-hovered'
          onClick={onCancel}
          disabled={isDisabled}
        >
          Cancel
        </Button>
        <Button
          type='button'
          size='lg'
          className='bg-dark-blue hover:bg-dark-blue-hovered'
          onClick={onSave}
          disabled={isSaving || isSubmitting || isDisabled}
        >
          {isSaving ? 'Saving...' : 'Save'}
        </Button>
        <Button
          type='submit'
          size='lg'
          className='bg-dark-blue hover:bg-dark-blue-hovered'
          disabled={isSubmitting || isSaving || isDisabled}
        >
          {isSubmitting ? 'Deploying...' : 'Deploy'}
        </Button>
      </div>
    </div>
  )
}
